/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import { Dimensions } from 'react-native';
import styled from 'styled-components/native';
// import { getScaledValue } from 'renative';
import Icons from './../assets/icons';

const w = Dimensions.get('window').width;
const h = Dimensions.get('window').height;
export const getScaledValue = (value: number) => {
  return value * (h / 500);
};

export const hexToRgb = (hex: string) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    const n = parseInt(c.join(''), 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255].join(',');
  }
  return `255,255,255`;
};

export const Logo = styled(Icons).attrs({
  icon: 'logo',
  width: getScaledValue(90),
  height: getScaledValue(90),
})``;

export const Load = styled.ActivityIndicator.attrs((p: { flat?: boolean }) => ({
  color: 'white',
  marginTop: p.flat ? 0 : getScaledValue(40),
}))``;
